import { Content, ContentType } from "./content";

/**
 * Um conteúdo de uma mensagem que é do tipo Options.
 * Este tipo carrega consigo uma lista de opções onde o usuário poderá escolher apenas uma.
 * 
 * A forma como as opções devem ser exibidas depende do tipo de "Display" informado.
 */
export class OptionsContent extends Content {
    options: Option[] = [];
    title: string;
    display: OptionsDisplay;

    constructor(title: string = "", display: OptionsDisplay = OptionsDisplay.BUTTON) {
        super();
        this.title = title;
        this.display = display;
    }

    getType(): ContentType {
        return ContentType.OPTIONS;
    }

}

/**
 * Formas como as opções de um OptionsContent podem ser exibidas na tela.
 */
export enum OptionsDisplay {
    DROPDOWN = "dropdown",
    BUTTON = "button",
    SELECTION_LIST = "selection",
    SIMPLE_LIST = "list"
}

/**
 * Define uma Option, contendo Label e Value.
 */
export class Option {
    label: string;
    value: string;
    showValue: boolean;

    constructor(label: string, value: string, showValue: boolean = true) {
        this.label = label;
        this.value = value;
        this.showValue = showValue;
    }

}